import http from '@/utils/http'

const detailsApi = {
  // 获取详细信息
  getDetails(data: any) {
    return http.get<any>('/business/resource/purchase/detail', { data })
  },

  // 点击优惠下单
  buy(data: any) {
    return http.get<any>('/business/resource/purchase/order/initialize', { data })
  }

}

export default detailsApi